import {get} from '@stubhub/rest-method';

import ListingModelInterface from './interface';

export default function ListingModel() {
  const path = '/inventory/listings/v2/{LISTINGID}';

  return {
    get: async ({listingId, headers: requestHeaders, ...args}) => {
      const headers = {
        'Accept-Language': 'en-us',
        Authorization: process.env.REACT_APP_API_SECRET,
        ...requestHeaders,
      };

      const defaults = {
        host: process.env.REACT_APP_API_HOST,
        path: path.replace('{LISTINGID}', listingId),
        headers,
        json: true,
      };

      const resultingConfig = {...defaults, ...args};

      return await get(resultingConfig).then((resp) => ListingModelInterface(resp));
    },
  };
}
